export default __webpack_public_path__ + "static/color-spots-light-6b9b3903fe8c65923c012c3b9b9acbaed001c051be073a38d858c4baff82c469.png";